export const meta = {
  appAlias: 'restaurant-menu',
  appName: 'Restaurant Menu'
};
